/* ============================================================
   BLOOMI THEME JS v2 — Production
   ============================================================ */
(function () {
  'use strict';

  /* --- FAQ Accordion --- */
  function initFAQ() {
    document.querySelectorAll('.bl-faq-trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item   = this.closest('.bl-faq-item');
        var isOpen = item.classList.contains('is-open');
        var list   = item.closest('.bl-faq-list');

        if (list) {
          list.querySelectorAll('.bl-faq-item.is-open').forEach(function (el) {
            el.classList.remove('is-open');
            el.querySelector('.bl-faq-trigger').setAttribute('aria-expanded', 'false');
          });
        }

        if (!isOpen) {
          item.classList.add('is-open');
          this.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* --- Scroll Reveal (individual .bl-reveal elements) --- */
  function initScrollReveal() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.bl-reveal').forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -36px 0px' });

    document.querySelectorAll('.bl-reveal').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* --- Staggered Grid Entrance (.bl-stagger children get bl-reveal + delay) --- */
  function initStagger() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.bl-stagger > *').forEach(function (el) {
        el.classList.add('bl-reveal', 'is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        Array.from(entry.target.children).forEach(function (child) {
          child.classList.add('bl-reveal');
        });
        setTimeout(function () {
          Array.from(entry.target.children).forEach(function (child) {
            child.classList.add('is-visible');
          });
        }, 40);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -24px 0px' });

    document.querySelectorAll('.bl-stagger').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* --- Sticky Mobile CTA (hides after user scrolls past hero) --- */
  function initStickyCTA() {
    var cta = document.getElementById('bl-sticky-cta');
    if (!cta) return;

    var hero = document.querySelector('.bl-hero-wrap');
    if (!hero) { cta.classList.add('bl-sticky-cta--visible'); return; }

    var show = false;

    function onScroll() {
      var heroBottom = hero.getBoundingClientRect().bottom;
      if (heroBottom < 0 && !show) {
        show = true;
        cta.style.transform = 'translateY(0)';
        cta.style.opacity   = '1';
      } else if (heroBottom >= 0 && show) {
        show = false;
        cta.style.transform = 'translateY(100%)';
        cta.style.opacity   = '0';
      }
    }

    cta.style.transform  = 'translateY(100%)';
    cta.style.opacity    = '0';
    cta.style.transition = 'transform .3s ease, opacity .3s ease';
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* --- Init --- */
  function init() {
    initFAQ();
    initScrollReveal();
    initStagger();
    initStickyCTA();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
